import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ServiceLocatorService } from '@ncs/ncs-lib';

export interface DahodData {
  region: string;
  totalBlock: number;
  totalSector: number;
  totalCenter: number;  
  openCentersYes: number;
  openCentersNo: number;
  morningMealCount: number;
  morningDishYes: number;
  morningDishNo: number;
  childrenMorningMealYes: number;
  childrenMorningMealNo: number;
  milkPouchCount: number;
  photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeYes: number;
  photoofChildrenDrinkingMilkUnderDoodhSanjeevaniSchemeNo: number;
  afternoonMealCount: number;
  afternoonDishYes: number;
  afternoonDishNo: number;
  afternoonEatYes: number;
  afternoonEatNo: number;
  poshanDish: number;
  photoOfBeneficiariesPresentForTheNutritionEnhancementNo : number;
  photoOfBeneficiariesPresentForTheNutritionEnhancementYes : number;
  preEducationCount: number;
  preEducationYes: number;
  preEducationNo: number;
  qualityOfHotSnacksAndNutritionEnhancedMealsGood: number;
  qualityOfHotSnacksAndNutritionEnhancedMealsAverage: number;
  qualityOfHotSnacksAndNutritionEnhancedMealsBad: number;
}


@Component({
  selector: 'app-dahod-dashboard',
  templateUrl: './dahod-dashboard.component.html',
  styleUrls: ['./dahod-dashboard.component.scss']
})
export class DahodDashboardComponent implements OnInit {
  dahodDataList: any = [];

  constructor(
    public locator: ServiceLocatorService,  
    private cdr: ChangeDetectorRef
  ) {
  
   
  }

  ngOnInit(): void {
   this.tempSelectedArea='sector'
    this.getDahodDashboardData();
  }
  form = {
  startDate: this.getTodayDate(),  
  endDate: null,    
  selectedArea: 'sector'
};

// Helper function
getTodayDate(): string {
  const today = new Date();
  return today.toISOString().split('T')[0];  
}
  tempSelectedArea: string = '';
  onFilter() {
    this.form.selectedArea = this.tempSelectedArea;
    this.getDahodDashboardData();
  }
  getDahodDashboardData() {
    let _self = this;
    this.locator.config
      .getProperty('endpoint.dahodDashboard')
      .then((property: string) => {
        const url = property + '/dashboard';
        _self.locator.http.post(url, this.form,function (res: any, error: boolean) {
          if (error) {
            alert('Server Error: ' + error);
            return;
          }
          console.log(" res.result['data']", res.result['data'])
          _self.dahodDataList = res.result['data'];
        });
      });
  }

  // getTotal(column:any): number {
  //   return this.dahodDataList.reduce((acc:any, curr:any) => acc + (curr[column] || 0), 0);
  // }
  getPercentageOfCenters(column: keyof DahodData, base:any): string {
    const total = this.getTotal(column);  
    if (base === 0) return '0%';
    return ((total / base) * 100).toFixed(2) + '%';
  }

  getTotal(column: keyof DahodData): number {
    return this.dahodDataList.reduce((acc:any, curr:any) => acc + (curr[column] || 0), 0);
  }

  areaOptions = [
    { label: 'જીલ્લો', value: 'district' },
    { label: 'બ્લોક', value: 'block' },
    { label: 'સેજા', value: 'sector' }
  ];
  
  /**
   * Export data in PDF
   */
  public exportPDFData() {
    let _self = this;   

     this.locator.config
      .getProperty('endpoint.dahodDashboard')
       .then((property: string) => {
          let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
          let sid = localStorage.getItem(keySuffix + 'sessionId');
         if (!sid) {
              sid = '0';
            }
          let url = property +'/dashboard'+'/pdf'+';jsessionid=' + sid;
         
         _self.locator.http
      .getClient()
      .post(url, this.form, { responseType: 'blob', })
      .subscribe(
        (data: any) => {
          _self.downloadDataAsFile(data, 'export.pdf');
        },
        (data: any) => {
          console.error(data);
        }
      );
      });
    
  }

  /**
   * Downalod data as file
   * @param data
   * @param fileName
   */
  public downloadDataAsFile(data: any, fileName: string) {
    //Create a dynamic link and download file
    let file = new window.Blob([data], { type: data.type });
    const downloadAncher = document.createElement('a');
    downloadAncher.style.display = 'none';
    const fileURL = URL.createObjectURL(file);
    downloadAncher.href = fileURL;
    downloadAncher.download = fileName;
    downloadAncher.click();
  }


// Example widths (in px) for sticky columns per area
 stickyWidthsByArea:any = {
  district: [50, 150, 150, 150],   // 4 sticky cols for district
  block: [50, 150, 150],           // 3 sticky cols for block
  sector: [50, 150],               // 2 sticky cols for sector
};

getStickyStyle(idx: number) {
  const area = this.form.selectedArea;
  const widths = this.stickyWidthsByArea[area] || [];

  console.log(area)
  console.log(widths)
  let left = 0;
  for (let i = 0; i < idx; i++) {
    if (i < widths.length) {
      left += widths[i];
    }
  }

  // Defensive: if idx out of range, fallback to default width
  const width = widths[idx] || 150;

  return {
    position: 'sticky',
    left: left + 'px',
    'z-index': 20 - idx,  
    width: width + 'px',
    // 'background-color': 'white',
    // Optional: add border-right or box-shadow for separation
    // 'border-right': '1px solid #ccc',
  };
}


getStickyCount(): number {
  switch (this.form.selectedArea) {
    case 'district': return 5;
    case 'block': return 4;
    case 'sector': return 3;
    default: return 1;
  }
}

}
